import React from "react";

const foreign_worker_modal_columns = (linkedProfiles, setLinkedProfiles) => [
  {
    Header: ({ data }) => {
      let allIds = data.map((item) => item.id);
      let allChecked = allIds?.length === linkedProfiles?.length;
      return (
        <>
          <input
            id={`allListed`}
            onClick={(e) => {
              if (e.currentTarget.checked) {
                setLinkedProfiles(allIds);
              } else {
                setLinkedProfiles([]);
              }
            }}
            className="usa-checkbox__input"
            type="checkbox"
            checked={allChecked}
          />
          <label
            className="usa-checkbox__label"
            style={{ margin: 0 }}
            htmlFor={`allListed`}
            onChange={(e) => e}
            checked={allChecked}
          />
        </>
      );
    },
    disableSortBy: true,
    id: "id",
    accessor: "id",
    fixedWidth: 65,
    Cell: ({ value, row: { index }, column: { id } }) => {
      const checked = linkedProfiles.includes(value);
      return (
        <>
          <input
            id={value}
            className="usa-checkbox__input"
            type="checkbox"
            checked={checked}
            onClick={(e) => {
              if (e.currentTarget.checked) {
                setLinkedProfiles((prev) => [...prev, value]);
              } else {
                setLinkedProfiles(linkedProfiles.filter((id) => id !== value));
              }
            }}
          />
          <label
            className="usa-checkbox__label"
            style={{
              padding: 0,
              margin: "2px 0",
              textIndent: 0,
            }}
            htmlFor={value}
            checked={checked}
          />
        </>
      );
    },
  },
  {
    Header: "Profile Name",
    id: "new_group_fw_group_name",
    accessor: (data) => data.new_group_fw_group_name,
    Cell: ({ value, row: { index }, column: { id } }) => <span>{value}</span>,
  },
];

export default foreign_worker_modal_columns;
